import Store from 'Services/Store';

window.Loc = {
    uilang: window.App.lang != undefined ? window.App.lang : 'fr',

    g: function(text) {
        return window.i18n.__(text);
    },

    getTimeHourFormat: function() {
        var format = Loc.getTimeFormat();
        if (Store.get('corp').hourformat == "12") {
            format += " hh:mm a";
        } else {
            format += " HH:mm";
        }
        return format;
    },
    getTimeFormat: function() {
        var format = "";
        if (Store.get('corp').timeformat == "dmy") {
            format += "DD/MM/YYYY";
        } else {
            format += "MM/DD/YYYY";
        }
        return format;
    }
};